/**
 * View More Case Studies – ScrambleText heading, native scroll carousel with drag, hover image + "view work" cursor follow
 */
(function () {
  'use strict';

  var SECTION_SEL = '[data-view-more-case-studies]';
  var HEADING_SEL = '[data-vmcs-heading]';
  var VIEWPORT_SEL = '[data-vmcs-viewport]';
  var TRACK_SEL = '[data-vmcs-track]';
  var CARD_SEL = '[data-vmcs-card]';
  var MEDIA_SEL = '[data-vmcs-card-media]';
  var VIEW_WORK_SEL = '[data-vmcs-view-work]';
  var VIDEO_WRAP_SEL = '[data-vmcs-card-video-wrap]';
  var PROGRESS_SEL = '[data-vmcs-progress]';
  var INIT_FLAG = 'vmcsInit';

  function initSection(section) {
    if (!section || section.dataset[INIT_FLAG] === '1') return;
    section.dataset[INIT_FLAG] = '1';

    // .csm__title is Case Study Main, .csm2__title is Case Study Main V2. Both need to match
    // or a case study page lists itself in its own "View More" carousel.
    var currentTitleEl = document.querySelector('.csm__title, .csm2__title');
    if (currentTitleEl) {
      var currentTitle = (currentTitleEl.textContent || '').trim().toLowerCase();
      if (currentTitle) {
        section.querySelectorAll(CARD_SEL).forEach(function (card) {
          var t = card.querySelector('.view-more-case-studies__card-title');
          if (!t) return;
          if ((t.textContent || '').trim().toLowerCase() === currentTitle) {
            card.parentNode && card.parentNode.removeChild(card);
          }
        });
      }
    }

    var headingEl = section.querySelector(HEADING_SEL);
    var headingTextEl = headingEl ? headingEl.querySelector('.view-more-case-studies__heading-text') : null;
    var viewport = section.querySelector(VIEWPORT_SEL);
    var track = section.querySelector(TRACK_SEL);
    var cards = section.querySelectorAll(CARD_SEL);
    var progressWrap = section.querySelector(PROGRESS_SEL);
    var progressFill = progressWrap ? progressWrap.querySelector('.view-more-case-studies__progress-fill') : null;
    var useGsap = typeof gsap !== 'undefined';

    // ----- Heading: ScrambleText on scroll into view -----
    function playHeadingAnimation() {
      var originalText = (headingTextEl && headingTextEl.textContent) || (headingEl && headingEl.textContent) || '';
      if (headingTextEl) headingTextEl.dataset.vmcsOriginalText = originalText;

      if (useGsap) {
        var hasScramble = typeof ScrambleTextPlugin !== 'undefined';
        if (hasScramble && originalText) {
          gsap.set(headingTextEl || headingEl, { opacity: 0 });
          gsap.to(headingTextEl || headingEl, {
            duration: 1.2,
            opacity: 1,
            scrambleText: {
              text: originalText,
              chars: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
              revealDelay: 0.2,
              speed: 0.5
            },
            ease: 'none'
          });
        } else {
          gsap.fromTo(headingTextEl || headingEl, { opacity: 0, y: 24 }, { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' });
        }
      }
    }

    if (typeof IntersectionObserver !== 'undefined') {
      var headingObserver = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            obs.unobserve(entry.target);
            playHeadingAnimation();
          });
        },
        { threshold: 0.35 }
      );
      if (headingEl) headingObserver.observe(headingEl);
    } else {
      playHeadingAnimation();
    }

    // ----- Cards: staggered entrance when section in view -----
    if (useGsap && cards.length) {
      gsap.set(cards, { opacity: 0, y: 24 });
      if (typeof IntersectionObserver !== 'undefined') {
        var cardsObserver = new IntersectionObserver(
          function (entries, obs) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              obs.unobserve(entry.target);
              gsap.to(cards, {
                opacity: 1,
                y: 0,
                duration: 0.7,
                stagger: { each: 0.12, from: 'start' },
                ease: 'power3.out'
              });
            });
          },
          { threshold: 0.2 }
        );
        if (track) cardsObserver.observe(track);
      } else {
        gsap.to(cards, { opacity: 1, y: 0, duration: 0.7, stagger: 0.12, ease: 'power3.out' });
      }
    }

    // Registry of per-card hover enter() handlers, populated in the hover loop below.
    // Used to re-trigger hover on the card under the cursor when a drag ends
    // (mouseenter doesn't fire when the mouse stays in place).
    var cardEnters = new WeakMap();

    // ----- Drag-to-scroll on viewport (with inertia) -----
    if (viewport) {
      var DRAG_THRESHOLD = 5;
      var pointerDown = false;
      var dragActive = false;
      var dragStartX = 0;
      var dragStartScroll = 0;
      var dragMoved = 0;
      var lastMoveX = 0;
      var lastMoveT = 0;
      var velocity = 0;
      var inertiaRaf = null;

      function stopInertia() {
        if (inertiaRaf !== null) {
          cancelAnimationFrame(inertiaRaf);
          inertiaRaf = null;
        }
      }

      function setDragging(on) {
        section.classList.toggle('is-dragging', on);
        viewport.classList.toggle('is-dragging', on);
      }

      function onDocPointerMove(e) {
        if (!pointerDown) return;
        var dx = e.clientX - dragStartX;
        if (!dragActive) {
          if (Math.abs(dx) < DRAG_THRESHOLD) return;
          // Threshold crossed: rebase origin so the first applied delta is 0 (no jump).
          dragActive = true;
          dragStartX = e.clientX;
          dragStartScroll = viewport.scrollLeft;
          lastMoveX = e.clientX;
          lastMoveT = performance.now();
          velocity = 0;
          dragMoved = 0;
          setDragging(true);
          return;
        }
        var now = performance.now();
        var dt = now - lastMoveT;
        if (dt > 0) {
          var instV = (e.clientX - lastMoveX) / dt; // px/ms
          velocity = velocity * 0.7 + instV * 0.3;
        }
        lastMoveX = e.clientX;
        lastMoveT = now;
        dragMoved = Math.abs(dx);
        viewport.scrollLeft = dragStartScroll - dx;
        if (e.cancelable) e.preventDefault();
      }

      function restoreHoverAt(x, y) {
        var el = document.elementFromPoint(x, y);
        if (!el) return;
        var card = el.closest && el.closest(CARD_SEL);
        if (!card || !section.contains(card)) return;
        var enter = cardEnters.get(card);
        if (enter) enter();
      }

      function onDocPointerUp(e) {
        document.removeEventListener('pointermove', onDocPointerMove);
        document.removeEventListener('pointerup', onDocPointerUp);
        document.removeEventListener('pointercancel', onDocPointerUp);
        if (!pointerDown) return;
        pointerDown = false;
        if (!dragActive) return;
        dragActive = false;
        setDragging(false);
        if (Math.abs(velocity) > 0.15) {
          inertiaRaf = requestAnimationFrame(runInertia);
        }
        if (e && typeof e.clientX === 'number') restoreHoverAt(e.clientX, e.clientY);
      }

      function runInertia() {
        velocity *= 0.94;
        viewport.scrollLeft -= velocity * 16;
        if (Math.abs(velocity) > 0.05) {
          inertiaRaf = requestAnimationFrame(runInertia);
        } else {
          inertiaRaf = null;
        }
      }

      viewport.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        if (e.button !== undefined && e.button !== 0) return;
        stopInertia();
        pointerDown = true;
        dragActive = false;
        dragMoved = 0;
        velocity = 0;
        dragStartX = e.clientX;
        lastMoveX = e.clientX;
        lastMoveT = performance.now();
        dragStartScroll = viewport.scrollLeft;
        document.addEventListener('pointermove', onDocPointerMove);
        document.addEventListener('pointerup', onDocPointerUp);
        document.addEventListener('pointercancel', onDocPointerUp);
      });

      viewport.addEventListener('click', function (e) {
        if (dragMoved > DRAG_THRESHOLD) {
          e.preventDefault();
          e.stopPropagation();
          dragMoved = 0;
        }
      }, true);

      // Prevent native HTML drag-and-drop on images/videos inside the carousel
      // (otherwise mousedown on a thumbnail starts an image-ghost drag).
      viewport.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    }

    // ----- Hover: same pattern as work-portfolio (homepage Our Work) – CSS hover frame + RAF cursor follow -----
    var mediaWraps = section.querySelectorAll(MEDIA_SEL);

    mediaWraps.forEach(function (wrap) {
      var card = wrap.closest(CARD_SEL);
      if (!card) return;
      var viewWork = wrap.querySelector(VIEW_WORK_SEL);
      var videoWrap = wrap.querySelector(VIDEO_WRAP_SEL);
      var video = videoWrap ? videoWrap.querySelector('video') : null;
      var link = card.tagName.toLowerCase() === 'a' ? card : card.querySelector('a');
      var followShouldRun =
        typeof window !== 'undefined' &&
        window.matchMedia &&
        window.matchMedia('(pointer: fine)').matches &&
        !!viewWork;
      var rafId = null;
      var lastX = 0;
      var lastY = 0;

      function onMouseMove(ev) {
        lastX = ev.clientX;
        lastY = ev.clientY;
        if (rafId === null) {
          rafId = requestAnimationFrame(function () {
            rafId = null;
            if (!viewWork) return;
            var rect = wrap.getBoundingClientRect();
            if (!rect.width || !rect.height) return;
            var relX = (lastX - rect.left) / rect.width;
            var relY = (lastY - rect.top) / rect.height;
            var leftPct = Math.min(95, Math.max(5, relX * 100));
            var topPct = Math.min(95, Math.max(0, relY * 100));
            if (useGsap) {
              gsap.to(viewWork, {
                duration: 0.25,
                left: leftPct + '%',
                top: topPct + '%',
                ease: 'expo.out',
                overwrite: true
              });
            } else {
              viewWork.style.left = leftPct + '%';
              viewWork.style.top = topPct + '%';
            }
          });
        }
      }

      function enter() {
        if (section.classList.contains('is-dragging')) return;
        wrap.classList.add('is-hovered');
        if (video) {
          try {
            video.currentTime = 0;
            video.play().catch(function () {});
          } catch (e) {}
          wrap.classList.add('is-video-active');
        }
        if (followShouldRun && viewWork) {
          try {
            wrap.addEventListener('mousemove', onMouseMove, { passive: true });
          } catch (e) {
            wrap.addEventListener('mousemove', onMouseMove);
          }
        }
      }

      function leave() {
        wrap.classList.remove('is-hovered');
        if (video) {
          try {
            video.pause();
          } catch (e) {}
          wrap.classList.remove('is-video-active');
        }
        wrap.removeEventListener('mousemove', onMouseMove);
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      }

      card.addEventListener('mouseenter', enter);
      card.addEventListener('mouseleave', leave);
      if (link) {
        link.addEventListener('focus', enter);
        link.addEventListener('blur', leave);
      }
      cardEnters.set(card, enter);
    });

    // ----- Progress bar for viewport scroll (CSS controls visibility per breakpoint) -----
    function updateProgress() {
      if (!progressFill || !viewport) return;
      var scrollLeft = viewport.scrollLeft;
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      var pct = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;
      progressFill.style.width = Math.min(Math.max(pct, 0), 100) + '%';
    }

    if (viewport && progressFill) {
      viewport.addEventListener('scroll', updateProgress, { passive: true });
      updateProgress();
    }
  }

  function initAll(container) {
    var sections = (container && container.querySelectorAll ? container : document).querySelectorAll(SECTION_SEL);
    Array.prototype.forEach.call(sections, initSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var sections = e.target.querySelectorAll(SECTION_SEL);
    Array.prototype.forEach.call(sections, function (s) {
      delete s.dataset[INIT_FLAG];
    });
  });
})();
